export enum IncomingChecksColumns {
	id = "Id",
	org = "Org",
	bank = "Bank",
	accountId = "Account",
	customer = "Customer",
	amount = "Amount",
	status = "Status",
	createdAt = "Created At",
}

export type AllowedIncomingChecksColumns =
	| IncomingChecksColumns.id
	| IncomingChecksColumns.org
	| IncomingChecksColumns.bank
	| IncomingChecksColumns.accountId
	| IncomingChecksColumns.customer
	| IncomingChecksColumns.amount
	| IncomingChecksColumns.status
	| IncomingChecksColumns.createdAt
